// Local notifications displayed throughout the product,
// but never in the notifications dropdown
export enum LocalProductNotificationType {
  GRAD_FAIRS_BANNER = 'GRAD_FAIRS_BANNER',
  ORG_ADMIN_ATS_SURVEY_BANNER = 'ORG_ADMIN_ATS_SURVEY_BANNER',
  UPLOAD_RESUME = 'UPLOAD_RESUME',
  SALARY_SURVEY_CTA = 'SALARY_SURVEY_CTA',
}
